import { format } from 'date-fns'
import { Updatable } from '../../core/models/updatable'
import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  DynamicBinding,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'
import { Category } from './category'
import { EngineerWorkingDay } from './engineer-working-day'

export class BaseEngineer extends Updatable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new BaseEngineer(), {
      category: new SerialisationConfig(() => new Category()),
      workingDays: new SerialisationConfig(() => new EngineerWorkingDay()),
    })
  override mandatory = ['id']

  @alias('id')
  id!: number
  @alias('numeric_id')
  numericID!: number
  @alias('first_name')
  firstName!: string
  @alias('last_name')
  lastName!: string
  @alias('email')
  email!: string
  @alias('category')
  category!: Category | null
  @alias('auth_code')
  authCode!: string
  @alias('sign_in_code')
  signInCode!: string
  @alias('basic')
  basic = 8.5
  @alias('weekend_basic')
  weekendBasic = 0.5
  @alias('productivity')
  productivity = 1
  @alias('postcode')
  postcode!: string
  @alias('latitude')
  latitude!: number
  @alias('longitude')
  longitude!: number
  @alias('last_seen_at')
  lastSeen!: Date | null
  @alias('has_left')
  left!: boolean
  @alias('is_locked')
  locked!: boolean
  @alias('has_no_reporting')
  noReporting!: boolean
  @alias('portal_token_expires_at')
  portalTokenExpires!: Date
  @alias('breathe_identifier')
  breatheID!: string | null
  @alias('working_days')
  workingDays!: EngineerWorkingDay[] | null
  @alias('created_at')
  created!: boolean
  @alias('updated_at')
  updated!: boolean
  @alias('deleted')
  deleted!: boolean
  @alias('morph_type')
  morphType!: string

  constructor(aliases?: unknown) {
    super(
      aliases == null
        ? (BaseEngineer as unknown as AliasedConstructor)._alias
        : Object.assign(
            {},
            (BaseEngineer as unknown as AliasedConstructor)._alias,
            aliases
          )
    )
  }

  get name(): string {
    if (this.firstName != null && this.lastName != null) {
      return `${this.firstName} ${this.lastName}`
    } else if (this.firstName != null) {
      return this.firstName
    } else if (this.lastName != null) {
      return this.lastName
    } else {
      return 'Engineer'
    }
  }

  get lastCheckIn(): string {
    return this.lastSeen ? format(this.lastSeen, 'dd/MM/yyyy HH:mm') : '-'
  }

  override serialise(): object {
    const data = super.serialise() as DynamicBinding
    if (Object.prototype.hasOwnProperty.call(data, 'category')) {
      data['category_id'] = this.category?.id ?? null
      delete data['category']
    }
    return data
  }

  static create<Data>(attrs: Data) {
    return new BaseEngineer().update(attrs, BaseEngineer.serialisationConfig)
  }
}
